import { render, staticRenderFns } from "./DocumentAndPdfTypeSlot.vue?vue&type=template&id=5a70669e&scoped=true"
import script from "./DocumentAndPdfTypeSlot.vue?vue&type=script&lang=ts"
export * from "./DocumentAndPdfTypeSlot.vue?vue&type=script&lang=ts"
import style0 from "./DocumentAndPdfTypeSlot.vue?vue&type=style&index=0&id=5a70669e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a70669e",
  null
  
)

export default component.exports